export default "__VITE_ASSET__66b78bc1__"